function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.44971 22H18.5503C20.8574 22 22 20.8574 22 18.5942V5.40576C22 3.14258 20.8574 2 18.5503 2H5.44971C3.15356 2 2 3.13159 2 5.40576V18.5942C2 20.8684 3.15356 22 5.44971 22ZM5.47168 20.2312C4.37305 20.2312 3.7688 19.6489 3.7688 18.5063V5.49365C3.7688 4.35107 4.37305 3.7688 5.47168 3.7688H18.5283C19.616 3.7688 20.2312 4.35107 20.2312 5.49365V18.5063C20.2312 19.6489 19.616 20.2312 18.5283 20.2312H5.47168Z",
  fill: "#878793"
});

function SvgIconCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon-checkbox.0d7dc7c0.svg";
export { ForwardRef as ReactComponent };